<span>
  {{data.message}}
</span>
